/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#000"
      d="M17.025 15.975c.3.3.3.75 0 1.05a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225L12 13.05l-3.975 3.975a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225c-.3-.3-.3-.75 0-1.05L10.95 12 6.975 8.025c-.3-.3-.3-.75 0-1.05s.75-.3 1.05 0L12 10.95l3.975-3.975c.3-.3.75-.3 1.05 0s.3.75 0 1.05L13.05 12z"
    />
    <mask
      id="close-icon_svg__a"
      width={12}
      height={12}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M17.025 15.975c.3.3.3.75 0 1.05a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225L12 13.05l-3.975 3.975a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225c-.3-.3-.3-.75 0-1.05L10.95 12 6.975 8.025c-.3-.3-.3-.75 0-1.05s.75-.3 1.05 0L12 10.95l3.975-3.975c.3-.3.75-.3 1.05 0s.3.75 0 1.05L13.05 12z"
      />
    </mask>
    <g mask="url(#close-icon_svg__a)">
      <path fill="#FF2929" d="M3 3h18v18H3z" />
    </g>
    <rect width={23} height={23} x={0.5} y={0.5} stroke="#FF2929" rx={3.5} />
  </svg>
)
export default SvgCloseIcon
